import { format, isValid, parseISO } from 'date-fns'

/**
 * Display formatting — trimmed to what this app actually uses. The tenant
 * app's lib/format.js has grievance-specific helpers (deadlines, currency,
 * duration) that have no meaning here; copying the whole file would carry
 * dead code for concepts (SLA, resolution time) this panel never shows.
 */

function toDate(value) {
  if (!value) return null

  const date = typeof value === 'string' ? parseISO(value) : new Date(value)

  return isValid(date) ? date : null
}

export function formatDate(value, fallback = '—') {
  const date = toDate(value)
  return date ? format(date, 'd MMM yyyy') : fallback
}

export function formatDateTime(value, fallback = '—') {
  const date = toDate(value)
  return date ? format(date, 'd MMM yyyy, h:mm a') : fallback
}

export function initials(name) {
  if (!name) return '?'

  return String(name)
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase()
}

const ACTIVITY_VERBS = {
  'tenant.provisioned': 'provisioned',
  'tenant.suspended': 'suspended',
  'tenant.reactivated': 'reactivated',
  'tenant.migrated': 'ran migrations for',
  'tenant.backed_up': 'downloaded a backup of',
  'tenant.deleted': 'permanently deleted',
  'admin.added': 'added a platform administrator',
  'admin.revoked': 'revoked a platform administrator',
}

/** The verb phrase for a PlatformActivityLog `action` value, e.g. "suspended". */
export function actionVerb(action) {
  return ACTIVITY_VERBS[action] ?? action
}
